export default "/images/framework/MyScoreCht.e63aadfd.svg?e63aadfd";